// extracted by mini-css-extract-plugin
export default {"pageButton":"PageButton_pageButton__+z6q7","value":"PageButton_value__OsWFV","pageButton_active":"PageButton_pageButton_active__7PJLO"};